import React, { MutableRefObject } from 'react';
import { Ref, useState, forwardRef, ReactElement, useEffect, ChangeEvent, useRef, SyntheticEvent, Fragment, useMemo, ComponentType } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import EmojiPicker from 'emoji-picker-react';
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import Fade, { FadeProps } from '@mui/material/Fade'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
// ** Icons Imports
import Close from 'mdi-material-ui/Close'
import IconButton from '@mui/material/IconButton'
import Google from 'mdi-material-ui/Google'
import Facebook from 'mdi-material-ui/Facebook'
import Pinterest from 'mdi-material-ui/Pinterest'
import Instagram from 'mdi-material-ui/Instagram'
//import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import DatePicker from 'react-datepicker'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuList from '@mui/material/MenuList'
import ButtonGroup from '@mui/material/ButtonGroup'

// ** Custom Imports
import MediaLibraryDialog from 'src/components/MediaLibraryDialog';
import FileUploaderCompact from 'src/components/FileUploaderCompact'
import { Utility } from 'src/utilities/Utility'
import contentApiService from "../../../../services/ContentService"
import { AppDispatch } from 'src/store'
import { RootState } from 'src/store'
import { fetchAllAvailableChannels } from 'src/store/apps/channel'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import { Icon } from '@iconify/react';
import axios from '../../../../services/ApiService'
import { ChannelType, channelDefault } from 'src/types/apps/channelTypes'
import GptSuggestionsDialog from '../../../../components/GPTSuggestionsDialog';
import { BoardDto, GetAllBoardsResponseDto, suggestedTimeDefault, SuggestedTimeDTO } from '../../../../types/viewmodels/genericTypes';
import Alert from '@mui/material/Alert'
import ListItemIcon from '@mui/material/ListItemIcon';
import LibraryAdd from '@mui/icons-material/LibraryAdd';

import Avatar from '@mui/material/Avatar';
import ListItemText from '@mui/material/ListItemText';
import { Campaign } from '../../../../types/apps/Campaign';
import Chip from '@mui/material/Chip';
import { getCampaigns } from '../../../../store/apps/campaign';
import { ApiResponse, handleApiResponse } from '../../../../components/ApiResponseToast';
import toast, { Toaster } from 'react-hot-toast';
import Autocomplete from '@mui/material/Autocomplete'
import Badge from '@mui/material/Badge';
import { Link, Stack, SvgIconProps, FormHelperText, Popover } from '@mui/material';
import Divider from '@mui/material/Divider';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import CloseIcon from 'mdi-material-ui/Close';

import PexelsSearch from '../../../../components/PexelsSearch';
import { useNavigate } from 'react-router-dom';
import { isSameDay } from 'date-fns';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface ContentDialogProps {
    show: boolean
    setShow: (arg0: boolean) => void
    prefilledModelData?: any //used when editing/update data
    campaign?: Campaign
}

interface FileProp {
    file: File;
    orgFn: string;
    size?: number;
    [key: string]: any;
}

interface InputFieldWithEmojiPickerProps {
    label: string;
    value: string;
    fieldName: string;
    onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    errorMessage?: string;
    required?: boolean;
    caretPositionRef: MutableRefObject<number>;
    setFieldTouched: (fieldname: string) => void;
    disabled?: boolean;
}

interface PostContentModel {
    message: string;
    pinterestTitle: string;
    instagramCaption: string;
    threadsCaption: string;
    linkedInCaption: string;
    discordMessage: string;
    redditTitle: string; 
    redditSrSlug?: string;
    channelsData: any;
    title: string;
    tags: string;
    categoryId: string;
    privacyStatus: string;
    publishAndNotifySubscribers: boolean;
    madeForKids: boolean;
    allowEmbedding: boolean;
    scheduleTime: any;
    id: number;
    campaignGuid?: string;
    fileMap: { filename: string; orgfn: string; url?: string }[];
    status: string;
}

interface UploadedFile {
    filename: string;
    orgfn: string;
    file: File;   
}

interface LibraryFile {
    filename: string;
    orgfn: string;
    url: string;  
}

type MediaFile = UploadedFile | LibraryFile;

const Transition = forwardRef(function Transition(
    props: FadeProps & { children?: ReactElement<any, any> },
    ref: Ref<unknown>
) {
    return <Fade ref={ref} {...props} />
})

const IMAGE_EXT = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.tiff'];
const VIDEO_EXT = ['.mp4', '.mov', '.m4v', '.webm', '.avi', '.mkv', '.wmv', '.flv', '.mpeg', '.mpg'];

function InputFieldWithEmojiPicker({
    label,
    fieldName,
    value,
    onChange,
    errorMessage,
    required,
    caretPositionRef,
    setFieldTouched,
    disabled = false
}: InputFieldWithEmojiPickerProps) {
    const [openEmojiPicker, setOpenEmojiPicker] = useState(false);
    const inputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null);

    return (

        <Box sx={{ mb: 2, mt: 2 }}>
            <TextField
                label={label}
                multiline
                variant="standard"
                required={required}
                value={value}
                onChange={onChange}
                onBlur={(event) => {
                    const caretPos = event.target.selectionStart ?? 0;
                    caretPositionRef.current = caretPos;
                    setFieldTouched(fieldName);
                }}
                inputRef={inputRef}
                fullWidth
                disabled={disabled}
                error={!!errorMessage}
                helperText={errorMessage}
                InputProps={{
                    endAdornment: (
                        <IconButton onClick={() => setOpenEmojiPicker(true)} disabled={disabled}>
                            <Icon icon="ic:sharp-emoji-emotions" width="24" height="24" />
                        </IconButton>
                    ),
                }}
            />
            <Popover
                open={openEmojiPicker}
                anchorEl={inputRef.current}
                onClose={() => setOpenEmojiPicker(false)}
                //disabled={disabled}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <EmojiPicker
                    onEmojiClick={(emojiData) => {
                        const msgPosition = caretPositionRef.current;
                        const messageMod =
                            value.slice(0, msgPosition) + emojiData.emoji + value.slice(msgPosition);
                        onChange({ target: { value: messageMod } } as ChangeEvent<HTMLInputElement>);
                        setOpenEmojiPicker(false);
                    }}
                />
            </Popover>
        </Box>
    );
}

const PostContentDialog = (props: ContentDialogProps) => {
    const { show, setShow, prefilledModelData, campaign } = props
    const [files, setFiles] = useState<any[]>([]);
    const [message, setMessage] = useState<string>("");
    const [pinterestTitle, setPinterestTitle] = useState<string>("");
    const [instagramCaption, setInstagramCaption] = useState<string>("");
    const [threadsCaption, setThreadsCaption] = useState<string>("");
    const [linkedInCaption, setLinkedInCaption] = useState<string>("");
    const [redditTitle, setRedditTitle] = useState<string>('');
    const [discordMessage, setDiscordMessage] = useState<string>('');
    const [xTitle, setXTitle] = useState<string>('');

    const [videoTitle, setVideoTitle] = useState<string>("");
    const [privacyStatus, setPrivacyStatus] = useState<string>("");
    const [videoCategories, setVideoCategories] = useState<any>([]);
    const [contentCategory, setContentCategory] = useState<string>("");
    const [videoTags, setVideoTags] = useState<string>("");
    const [madeForKids, setMadeForKids] = useState<boolean>(false);
    const [allowEmbedding, setAllowEmbedding] = useState<boolean>(false);
    const [publishAndNotifySubscribers, setPublishAndNotifySubscribers] = useState<boolean>(false);
    const [channelId, setChannelId] = useState<string>('')
    const [channelType, setChannelType] = useState<string>('')
    const [originalChannelId, setOriginalChannelId] = useState<number>(0);
    const [status, setStatus] = useState<string>('');
    const [postId, setPostId] = useState<number>(0);
    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const store = useSelector((state: RootState) => ({ channel: state.channel, lookup: state.lookup }))

    // REDDIT: target selection
    const [redditTarget, setRedditTarget] = useState<'profile' | 'subreddit'>('profile');
    const [redditProfileSlug, setRedditProfileSlug] = useState<string>(''); 
    const [redditSubs, setRedditSubs] = useState<{ name: string; iconUrl?: string }[]>([]);
    const [redditSelectedSub, setRedditSelectedSub] = useState<string>(''); // plain subreddit name

    const messageCaretPositionRef = useRef<number>(0);
    const instagramCaretPositionRef = useRef<number>(0);
    const threadsCaretPositionRef = useRef<number>(0);
    const linkedInCaretPositionRef = useRef<number>(0);
    const pinterestCaretPositionRef = useRef<number>(0);
    const redditTitleCaretRef = useRef<number>(0);
    const xTitleCaretRef = useRef<number>(0);
    const discordMessageCaretRef = useRef<number>(0);

    let options = ['Post Now', 'Schedule for Later', 'Save As Draft'];
    const [selectedIndex, setSelectedIndex] = useState<number>(0);
    const [popperOpen, setPopperOpen] = useState<boolean>(false);
    const [showDateTimeComponent, setShowDateTimeComponent] = useState<boolean>(false);
    const [scheduledDateTime, setScheduledDateTime] = useState<Date | null>(new Date());
    const [availableChannels, setAvailableChannels] = useState<ChannelType[]>(channelDefault);
    const [isDefaultOrgActive, setIsDeafultOrgActive] = useState<boolean>(false);
    const [content, setContent] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [fBDTErrMessage, setFBDTErrMessage] = useState('');
    const [suggestedTimeModel, setSuggestedTimeModel] = useState<SuggestedTimeDTO>(suggestedTimeDefault);
    const [errors, setErrors] = useState<string[]>();
    const [formValidationErrors, setFormValidationErrors] = useState<any>({});
    const [selectedChannelIds, setSelectedChannelIds] = useState<string[]>();
    const [tokenErrors, setTokenErrors] = useState<UserAccessTokenValidationResultDTO[]>();
    const [fileErrorMessage, setFileErrorMessage] = useState<string>('');
    const [fieldTouched, setFieldTouchedState] = useState<{ [key: string]: boolean }>({});
    const [showPexelsSearch, setShowPexelsSearch] = useState<boolean>(false);
    const [videoImage, setVideoImage] = useState<string>('');

    /* Media library states */
    const [showLibraryDialog, setShowLibraryDialog] = useState(false);
    const [attachedDesigns, setAttachedDesigns] = useState<any[]>([]);

    const hasExt = (url: string | undefined, exts: string[]) =>
        !!url && exts.some(ext => url.toLowerCase().split('?')[0].endsWith(ext));

    const libItemKind = (d: any): 'image' | 'video' | null => {
        const mime = d?.mimeType || d?.contentType;
        const url = d?.url || d?.thumbnailUrl;
        if (mime?.startsWith?.('video') || hasExt(url, VIDEO_EXT)) return 'video';
        if (mime?.startsWith?.('image') || hasExt(url, IMAGE_EXT)) return 'image';
        return null;
    };

    const navigate = useNavigate();

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const isFromCreatePost = params.get('action') === 'createPost';
    const hasBlockingError = !!(
        (tokenErrors && tokenErrors.length > 0) ||
        (suggestedTimeModel && suggestedTimeModel.statusColorCode === 1) || (!campaign) 
    );

    const disabled = !hasBlockingError;

    const showPostAsDraft = postId === 0;

    if (!showPostAsDraft) {
        options = options.filter(option => option !== 'Save As Draft');
    }

    const dispatch = useDispatch<AppDispatch>()


    let minDate = new Date();

    useEffect(() => {
        const url = new URL(window.location.href);

        if (url.searchParams.get("reopenPostDialog") === "1") {
            setOpen(true);

            url.searchParams.delete("reopenPostDialog");
            window.history.replaceState({}, "", url.pathname + url.search + url.hash);
        }
    }, []);

    useEffect(() => {
        if (scheduledDateTime !== null) {
            getInsightsforChannel();
        }
    }, [scheduledDateTime]);

    //@ts-ignore
    const ErrorDisplay = ({ children }) => {
        if (!children || (children && children.length === 0)) {
            return null;  // Return null if no children exist or they are just empty spaces
        }
        return (
            <Box sx={{
                padding: 1,
                backgroundColor: '#ffebee',
                border: '1px solid #ef9a9a',
                borderRadius: '4px',
                marginTop: 2,
                marginBottom: 1,
            }}>
                <Typography variant="body2" color="error" component="div">
                    {children}
                </Typography>
            </Box>
        );
    };



    //#region Form Validation, Label Updates and Show Hide logic for fields

    const setFieldTouched = (fieldname: string): void => {
        setFieldTouchedState(prevState => ({
            ...prevState,
            [fieldname]: true
        }));
    };

    const checkandHandleFormValidation = (): boolean => {

        const newErrors: any = {};
        if (fieldTouched.channelSelection && !selectedChannelIds || (selectedChannelIds && selectedChannelIds.length === 0)) {
            newErrors.channelSelection = [
                `Channel Selection is required.`,
            ];
        }
        if (doesSelectedChannelsContainsMedium("facebook")) {
            if (fieldTouched.message && !message) {
                newErrors.message = [
                    `${getLabelForMessageField()} is required.`,
                ];
            }
        }
        if (doesSelectedChannelsContainsMedium("google")) {
            if (fieldTouched.message && !message) {
                newErrors.message = [
                    `${getLabelForMessageField()} is required.`,
                ];
            }
            if (fieldTouched.videoTitle && !videoTitle) {
                newErrors.videoTitle = [
                    "Video Title is Required.",
                ];
            }
            if (fieldTouched.privacyStatus && !privacyStatus) {
                newErrors.privacyStatus = [
                    "Privacy Status is Required.",
                ];
            }
            if (fieldTouched.contentCategory && !contentCategory) {
                newErrors.contentCategory = [
                    "Content Category is Required.",
                ];
            }
            if (fieldTouched.privacyStatus && !privacyStatus) {
                newErrors.privacyStatus = [
                    "Privacy Status is Required.",
                ];
            }
        }
        if (doesSelectedChannelsContainsMedium("pinterest")) {
            if (fieldTouched.pinterestTitle && !pinterestTitle) {
                if (!Array.isArray(newErrors.pinterestTitle)) {
                    newErrors.pinterestTitle = [];
                }
                newErrors.pinterestTitle.push("Pin Title is Required")
            }
            if (fieldTouched.pinterestTitle && pinterestTitle && pinterestTitle.length > 100) {
                if (!Array.isArray(newErrors.pinterestTitle)) {
                    newErrors.pinterestTitle = [];
                }
                newErrors.pinterestTitle.push("Maximum allowed character limit for Pin Title is 100 characters.");
            }
        }

        if (doesSelectedChannelsContainsMedium('reddit')) {
            if (fieldTouched.message && !message) {
                newErrors.message = [
                    ...(newErrors.message ?? []),
                    'Reddit Caption is required.',
                ];
            }
            if (fieldTouched.redditTitle && !redditTitle) {
                newErrors.redditTitle = ['Reddit Title is required.'];
            }
            if (fieldTouched.redditTitle && redditTitle && redditTitle.length > 300) {
                newErrors.redditTitle = [
                    ...(newErrors.redditTitle ?? []),
                    'Maximum allowed length for Reddit Title is 300 characters.',
                ];
            }
            if (redditTarget === 'subreddit' && (!redditSelectedSub || !redditSelectedSub.trim())) {
                newErrors.redditTarget = ['Please choose a subreddit.'];
            }
        }

        setFormValidationErrors(newErrors);

        // Check if there are any errors before submitting the form
        if (Object.keys(newErrors).length === 0 && !fileErrorMessage) {
            return true;
        } else {
            return false;
        }
    };

    const doesSelectedChannelsContainsMedium = (mediumName: string): boolean => {
        return selectedChannels.some(c => c.mediumName.toLowerCase() == mediumName.toLowerCase());
    }

    const doesSelectedChannelsContainOnlyThisMedium = (mediumName: string): boolean => {
        const mediumNameLowerCase = mediumName.toLowerCase();
        const allMatch = selectedChannels.every(c => c.mediumName.toLowerCase() === mediumNameLowerCase);

        // Check if there's at least one channel with the provided mediumName
        const anyMatch = selectedChannels.some(c => c.mediumName.toLowerCase() === mediumNameLowerCase);

        // Return true only if all channels match the provided mediumName and at least one exists
        return allMatch && anyMatch;
    }

    const getLabelForMessageField = (): string => {
        let messageLabel = '';

        // Single-medium cases
        if (doesSelectedChannelsContainOnlyThisMedium('facebook')) return 'Facebook Message';
        if (doesSelectedChannelsContainOnlyThisMedium('google')) return 'Video Description';
        if (doesSelectedChannelsContainOnlyThisMedium('reddit')) return 'Reddit Caption';
        if (doesSelectedChannelsContainOnlyThisMedium('x')) return 'X Caption';
        if (doesSelectedChannelsContainOnlyThisMedium('discord')) return 'discord Message';

        // Mixed selection → concatenate
        if (doesSelectedChannelsContainsMedium('facebook')) {
            messageLabel += (messageLabel ? '/' : '') + 'Facebook Message';
        }
        if (doesSelectedChannelsContainsMedium('google')) {
            messageLabel += (messageLabel ? '/' : '') + 'Video Description';
        }
        if (doesSelectedChannelsContainsMedium('reddit')) {
            messageLabel += (messageLabel ? '/' : '') + 'Reddit Caption';
        }
        return messageLabel || 'Message';
    }


    const validateFiles = () => {
        // local uploads
        const hasVideoLocal = files.some(f => f.file?.type?.includes('video'));
        const hasImageLocal = files.some(f => f.file?.type?.includes('image'));

        // media library
        const libKinds = attachedDesigns.map(libItemKind).filter(Boolean) as ('image' | 'video')[];
        const hasVideoLib = libKinds.includes('video');
        const hasImageLib = libKinds.includes('image');

        const hasVideo = hasVideoLocal || hasVideoLib;
        const hasImage = hasImageLocal || hasImageLib;

        // YouTube (Google): no media-library items, and must be a video
        if (isGoogleSelected) {
            if (attachedDesigns.length > 0) {
                setFileErrorMessage('YouTube only accepts direct video uploads. Please remove Library items and upload a video file.');
                return;
            }
            if (!hasVideoLocal) {
                setFileErrorMessage('At least one uploaded video is required for YouTube.');
                return;
            }
            setFileErrorMessage('');
            return;
        }

        // Pinterest: image or video, from either source
        if (isPinterestSelected && !hasVideo && !hasImage) {
            setFileErrorMessage('At least one image or video is required for Pinterest.');
            return;
        }

        setFileErrorMessage('');

    }

    //#endregion


    const handleDateTimeChange = (date: Date) => {
        setFBDTErrMessage('');
        setScheduledDateTime(null);
        if (channelType == '1' || channelType == '2') {
            const currentTimePlus15 = new Date();
            currentTimePlus15.setMinutes(currentTimePlus15.getMinutes() + 15);

            if (date >= currentTimePlus15) { //As per Facebook policy post scheduled time should be atleast 10 minutes before the actual time, we are keeping it 15 minutes to avoid any errors
                setScheduledDateTime(date)
                if (dateHasTime(date)) {
                    setSelectedIndex(3);
                }
            } else {
                setFBDTErrMessage('Please select a time at least 15 minutes from now.');
            }
        }
        else {
            setScheduledDateTime(date)
            if (dateHasTime(date)) {
                setSelectedIndex(3);
            }
        }
    }

    const getInsightsforChannel = async (chId?: string) => {
        try {
            setSuggestedTimeModel(suggestedTimeDefault);
            let chanId: string = '';
            if (!chId) {
                if (channelId) {
                    chanId = channelId;
                }
                else {
                    return;
                }
            }
            else {
                chanId = chId;
            }
            let channelGuid = availableChannels.filter(p => p.channelId == chanId)[0].channelGuid;
            if (scheduledDateTime) {
                let dateTimeStr = scheduledDateTime.toISOString();
                var url = `/insight/GetInsights?channelGuid=${channelGuid}&selectedDateTime=${encodeURIComponent(dateTimeStr)}`;
                const response = await axios.get(url);
                if (response.data) {
                    let optimizedApiCallData = response.data;
                    setSuggestedTimeModel({
                        optimizationChoices: optimizedApiCallData.optimizationChoices,
                        optimizationMessage: optimizedApiCallData.optimizationMessage,
                        statusColorCode: optimizedApiCallData.statusColorCode
                    })
                }
            }
            //setSuggestions(response.data.suggestions);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        }
    }

    const getTitleMessage = () => {
        if (tokenErrors && tokenErrors.length > 0) {
            return tokenErrors.map((tokenError, index) => (
                <Alert severity="error" variant="outlined" key={index} sx={{ marginBottom: 2 }}>
                    {tokenError.error} <Link href="#" onClick={(e: any) => handleTokenExpiredLinkClick(tokenError.providerName, e)} sx={{ ml: 1 }}>Click here</Link> to refresh.
                </Alert>
            ))
        }
        if (campaign) {
            return <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Icon icon="logos:active-campaign-icon" color="primary" width="24px" height="24px" />
                <Typography variant="h6" component="div">
                    Campaign
                </Typography>
                <Chip label={campaign.name} color="primary" variant="filled" />
            </Box>
        }
        if (suggestedTimeModel.optimizationMessage) {
            const message = `${suggestedTimeModel.optimizationMessage}<br/>${suggestedTimeModel.optimizationChoices ? suggestedTimeModel.optimizationChoices : ''}`;
            return <Alert variant='outlined' severity={suggestedTimeModel.statusColorCode == 1 ? 'error' : 'success'} sx={{ width: "100%" }}>
                {message.split('<br/>').map((item, i) => <><span key={i} style={{ fontSize: "12px" }}>{item}</span><br /></>)}
            </Alert>
        }

            return null;

    }

    const fetchSuggestions = async () => {
        try {
            const response = await axios.post('/gpt/generateSuggestions', { Content: message });
            setSuggestions(response.data.suggestions);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        }
    };

    const handleShowSuggestions = async () => {
        await fetchSuggestions();
        setDialogOpen(true);
    };

    const handleSuggestionSelect = (suggestion: string) => {
        setMessage(suggestion);
        setDialogOpen(false);
    };


    const resetPostDialogForm = (resetOnlyVideoProps: boolean) => {
        if (!resetOnlyVideoProps) {
            setMessage("");
        }
        setPinterestTitle("");
        setInstagramCaption("");
        setThreadsCaption("");
        setLinkedInCaption("");
        setRedditTitle('');
        setXTitle('');
        setDiscordMessage('');
        setFiles([]);
        setVideoTitle("");
        setPrivacyStatus("");
        //setVideoCategories([]);
        setContentCategory("");
        setVideoTags("");
        setMadeForKids(false);
        setAllowEmbedding(false);
        setPublishAndNotifySubscribers(false);
        setLoading(false);
        setScheduledDateTime(null);
        setSelectedIndex(0);
        setSuggestedTimeModel(suggestedTimeDefault);
        setPostId(0);
        setStatus('');
    }

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(false);
    };

    const handleDateTimeTooltipClose = () => {
        setShowDateTimeComponent(false);
    };

    const handleDateTimeTooltipOpen = () => {
        setShowDateTimeComponent(true);
    };

    useEffect(() => {
        if (prefilledModelData && show) {
            console.log(prefilledModelData);
            let m = prefilledModelData;
            if (m?.message) setMessage(m.message);
            if (m?.pinterestTitle) setPinterestTitle(m.pinterestTitle);
            if (m?.instagramCaption) setInstagramCaption(m.instagramCaption);
            if (m?.threadsCaption) setThreadsCaption(m.threadsCaption);
            if (m?.linkedInCaption) setLinkedInCaption(m.linkedInCaption);
            if (m?.redditTitle) setRedditTitle(m.redditTitle);
            if (m?.xTitle) setXTitle(m.xTitle);
            if (m?.discordMessage) setDiscordMessage(m.discordMessage);

            if (m?.title) setVideoTitle(m.title);
            if (m?.privacyStatus) setPrivacyStatus(m.privacyStatus);
            if (m?.contentCategory) setContentCategory(m.contentCategory);
            if (m?.videoTags) setVideoTags(m.tags);
            if (m?.allowEmbedding) setAllowEmbedding(m.allowEmbedding);
            if (m?.publishAndNotifySubscribers) setPublishAndNotifySubscribers(m.publishAndNotifySubscribers);
            if (m?.scheduleTime) setScheduledDateTime(new Date(m.scheduleTime));
            //if (m?.channelId) setChannelId(m.channelId);
            //if (m?.originalChannelId) setOriginalChannelId(m.channelId);
            if (m?.madeForKids) setMadeForKids(m.madeForKids);
            //if (m?.channelId) setChannelId(m.originalChannelId.toString());
            //if (m?.channelTypeId) setChannelType(m.channelTypeId.toString());
            if (m?.pinterestTitle) setPinterestTitle(m.pinterestTitle);
            if (m?.id) setPostId(m.id);
            if (m?.status) {
                setStatus(m.status);
                if (m.status == "Scheduled") setSelectedIndex(1);
            }
            if (m?.errors) {
                setErrors(m.errors);
            }
            setSelectedIndex(1);
            getFilesForPost(m.id);
            //setSelectedChannelIds(prefilledModelData.channelsData.map((ch: { [x: string]: string; }) => ch["channelId"] + "|" + ch["channelTypeId"] + "|" + ch["originalChannelId"]));
            let patchedChannelsData = m.channelsData;
            if (
                (!Array.isArray(m.channelsData) || m.channelsData.length === 0) &&
                m.channelId && m.channelTypeId && m.channelName // adjust as per what you have
            ) {
                patchedChannelsData = [
                    {
                        channelId: m.channelId,
                        channelTypeId: m.channelTypeId,
                        originalChannelId: m.originalChannelId || m.channelId,
                        mediumName: m.mediumName || m.channelTypeName,
                    }
                ];
            }
            setSelectedChannelIds(
                Array.isArray(prefilledModelData.channelsData)
                    ? prefilledModelData.channelsData.map((ch: { [x: string]: string; }) =>
                        ch["channelId"] + "|" + ch["channelTypeId"] + "|" + ch["originalChannelId"]
                    )
                    : []
            );

        }
        else {
            resetPostDialogForm(false);
        }
    }, [prefilledModelData, show]);

    useEffect(() => {
        if (store.lookup.data.userOrgChannels) {
            let isDefaultOrgActive = store.lookup.data.userOrgChannels.organizations.some((uc) => uc.active && uc.isDefaultOrg);
            setIsDeafultOrgActive(isDefaultOrgActive);
            if (!isDefaultOrgActive) {
                let currentOrg = store.lookup.data.userOrgChannels.organizations.filter((uc) => uc.active)[0];
                setAvailableChannels(currentOrg.channels);
            }
            else {
                setAvailableChannels(store.channel.data);
            }
        }

    }, [store.channel.data, store.lookup.data.userOrgChannels]);

    useEffect(() => {
        dispatch(
            fetchAllAvailableChannels({
                dates: null,
                q: null,
                status: null
            })
        )
    }, [dispatch])

    useEffect(() => {
        errors && errors.length && displayErrors(errors);
    }, [errors])

    const displayErrors = (errors: string[]) => {
        errors.forEach(error => {
            toast.error(error, {
                style: {
                    backgroundColor: 'red',
                    color: 'white'
                },
                duration: 4000,
                position: 'top-center',
            });
        });
    };

    const getFilesForPost = (postId: number) => {
        axios.get(`/content/GetPostFiles?postId=${postId}`, {
            responseType: 'json'
        })
            .then(response => {

                let files: any[] = [];
                Object.keys(response.data).forEach(key => {
                    let file = response.data[key];
                    let blob = new Blob([file.fileBlob], { type: file.fileType });
                    let fileObj = new File([blob], file.fileName, { type: file.fileType, lastModified: new Date().getTime() });
                    let fileExtentedObj = { file: fileObj, orgFn: file.fileOriginalName, folderRefId: file.folderReference, videoThumbnailURL: file.videoThumbnailURL };
                    files.push(fileExtentedObj);
                    setFiles(files);
                    console.log(files)
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    useEffect(() => {
        if (!show) {
            resetPostDialogForm(false);
        }
    }, [show]);

    function buildFileMap(allMedia: MediaFile[]) {
        return allMedia.map(item => {
            if ('file' in item) {
                return {
                    filename: item.filename,
                    orgfn: item.orgfn,
                    url: undefined, 
                    isMediaLibraryFile: false
                };
            } else {
                return {
                    filename: item.filename,
                    orgfn: item.orgfn,
                    url: item.url,
                    isMediaLibraryFile: true
                };
            }
        });
    }

    function getAllSelectedMediaFiles(): MediaFile[] {
        const directFiles: UploadedFile[] = files.map(f => ({
            filename: f.file.name,
            orgfn: f.orgFn,
            file: f.file
        }));

        const libraryFiles: LibraryFile[] = attachedDesigns.map(d => ({
            filename: d.title || d.filename || d.id,
            orgfn: d.title || d.id,
            url: d.urls
        }));

        return [...directFiles, ...libraryFiles];
    }

    async function fetchFileAsBlob(url: string, name: string = "media-library-file.mp4") {
        const response = await fetch(url);
        console.log("Status:", response.status); 

        const blob = await response.blob();
        console.log("Blob size:", blob.size); 

        const arrayBuffer = await blob.slice(0, 16).arrayBuffer();
        const header = new Uint8Array(arrayBuffer);
        console.log("First bytes of file:", header);

        const contentType = response.headers.get("Content-Type");
        return new File([blob], name, { type: contentType || "video/mp4" });
    }


    const postContent = async (scheduleTime?: any, status: any = null) => {
        validateFiles();
        if (checkandHandleFormValidation() === false) {
            return;
        }
        if (scheduleTime && !isFutureDate(scheduleTime)) {
            //Add a Dialog here to show user why we are stopping him/her. This scenario can happen if the user has already chosen future scheduled time and keeps his/her window open until that time has passed
            //and then clicks the schedule button
            alert("Post can only be scheduled for future date time.")
            setSelectedIndex(1);
            return;
        }
        let channelsData: any = [];
        selectedChannels.map((channel: ChannelType) => channelsData.push({
            channelId: channel.channelId,
            channelTypeId: channel.channelTypeId,
            originalChannelId: channel.id //originalChannelId
        }));

        const allMedia = getAllSelectedMediaFiles();

        let filesToUpload: File[] = [];
        for (const item of allMedia) {
            if ('file' in item && item.file) {
                filesToUpload.push(item.file);
            } else if ('url' in item && item.url) {
                let ext = (item.url.split('.').pop() || "mp4").replace(/\?.*$/, ""); 

                let baseName = (item.filename || "media-library-file").replace(new RegExp("\\." + ext + "$", "i"), "");

                const name = `${baseName}.${ext}`;

                const file = await fetchFileAsBlob(item.url, name);
                filesToUpload.push(file);
            }
        }


        const fileMap = buildFileMap(allMedia);
        const redditSrSlug =
            doesSelectedChannelsContainsMedium('reddit')
                ? (redditTarget === 'profile' ? redditProfileSlug : redditSelectedSub || '')
                : '';

        let model: PostContentModel = {
            message,
            pinterestTitle,
            instagramCaption,
            threadsCaption,
            linkedInCaption,
            redditTitle, 
            discordMessage, 
            channelsData,
            title: videoTitle,
            tags: videoTags,
            categoryId: contentCategory,
            privacyStatus: privacyStatus,
            publishAndNotifySubscribers,
            madeForKids,
            allowEmbedding,
            scheduleTime: scheduleTime ? scheduleTime : null,
            id: postId,
            campaignGuid: campaign?.campaignGuid,
            fileMap,
            status,
            redditSrSlug,
        };

        console.log("Submitting Post Content Model:", model);

        let formData = Utility.convertModelToFormData(model, null);

        filesToUpload.forEach(file => {
            formData.append("files", file);
        });

        setLoading(true);
        let result: ApiResponse = await contentApiService.postToChannel(formData);
        handleApiResponse(result);
        setLoading(false);
        setShow(false);
        dispatch(getCampaigns());
    }
    const handleClose = () => {
        if (isFromCreatePost) {
            navigate('/pchannels');
        }
        setShow(false);
    }

    const updateFiles = (newFiles: FileProp[]) => {
        //let extendedFileObjArr = [];
        //extendedFileObjArr = files.map((file) => ({ file: file, orgFn: null }));
        setFiles(newFiles);
    }

    const handleRemoveFile = (file: FileProp) => {
        //const uploadedFiles = files
        const filtered = files.filter((i: FileProp) => i.file.name !== file.file.name);
        setFiles(filtered);
    }

    const renderFilePreview = (file: FileProp) => {
        if (file.type.startsWith('image')) {
            return <img width={38} height={38} alt={file.name} src={URL.createObjectURL(file as any)} />
        } else {
            return <><Icon icon="ic:baseline-insert-drive-file" width="30" height="30" />
            </>
        }
    }

    const isFutureDate = (date: Date): boolean => {
        const now = new Date();
        return date > now;
    }

    /*const fileList = files.map((fileObj: any) => (
        <ListItem key={fileObj.name} sx={{ border: "2px solid rgba(93, 89, 98, 0.22)" }}>
            <div className='file-details' style={{ width: "100%", display: "inline-flex", alignItems: "center" }}>
                <div className='file-preview'>{renderFilePreview(fileObj.file)}</div>
                <div>
                    <Typography className='file-name'>{fileObj.file.name}</Typography>
                </div>
            </div>
            <IconButton onClick={() => handleRemoveFile(fileObj.file)}>
                <Close fontSize='small' />
            </IconButton>
        </ListItem>
    ))*/

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));

    const menuButtonClicked = () => {
        if (selectedIndex == 0) {
            postContent();
        }
        else if (selectedIndex == 2) {
            setStatus("Draft");
            postContent(null, "Draft");
        }
        else if (selectedIndex == 3) {
            //append schedule time here
            postContent(scheduledDateTime);
        }
        else {
            handleDateTimeTooltipOpen();
            setShowDateTimeComponent(true);
        }
    }

    const handleMenuItemClick = (event: SyntheticEvent, index: number) => {
        setSelectedIndex(index)
        setScheduledDateTime(null);
        //if (index == 1) {
        //    setShowPostContentButton(false);
        //}
        setPopperOpen(false)
    }

    const handlePopperToggle = () => {
        setPopperOpen(prevOpen => !prevOpen)
    }

    const handlePopperClose = () => {
        setPopperOpen(false)
    }

    const ScheduleButton = forwardRef<any, any>(({ value, onClick }, ref) => {
        return <Button onClick={onClick} ref={ref} sx={{ borderRadius: 0, marginRight: 0 }}>
            Click to Schedule
        </Button>
    });

    const dateHasTime = (date: Date) => {
        return (
            date.getHours() > 0 ||
            date.getMinutes() > 0 ||
            date.getSeconds() > 0 ||
            date.getMilliseconds() > 0
        );
    }

    // ** Ref
    const anchorRef = useRef<HTMLDivElement | null>(null)

    const formatDate = (date: Date): string => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        let hours: any = date.getHours();
        let minutes: any = date.getMinutes();
        let ampm = "AM";

        if (minutes < 10) {
            minutes = "0" + minutes;
        }

        if (hours > 11) {
            ampm = "PM";
        }

        if (hours > 12) {
            hours = hours - 12;
        }

        if (hours === 0) {
            hours = 12;
        }

        return monthNames[monthIndex] + " " + day + ", " + hours + ":" + minutes + " " + ampm;
    }

    const selectedChannels = useMemo(() => {
        return availableChannels.filter(ch => selectedChannelIds?.includes(ch.channelId + "|" + ch.channelTypeId + "|" + ch.id));
    }, [availableChannels, selectedChannelIds]);

    const isGoogleSelected = useMemo(() => doesSelectedChannelsContainsMedium('google'), [selectedChannels]);
    const isPinterestSelected = useMemo(() => doesSelectedChannelsContainsMedium('pinterest'), [selectedChannels]);

    const styledIcon = <T extends ComponentType<SvgIconProps>>(IconComponent: T) => styled(IconComponent)(({ theme }) => ({
        fontSize: '10px',
    }));

    useEffect(() => {
        const needReddit = doesSelectedChannelsContainsMedium('reddit');

        async function fetchRedditAccounts() {
            try {
                const res = await axios.get('channel/reddit/accounts');
                const items: any[] = res.data || [];

                const me = items.find(i => (i.type || i.Type) === 'user');
                if (me) {
                    const slug = me.srSlug || (typeof me.DisplayName === 'string' && me.DisplayName.startsWith('u/')
                        ? `u_${me.DisplayName.slice(2)}`
                        : (me.displayName && String(me.displayName).startsWith('u/')
                            ? `u_${String(me.displayName).slice(2)}`
                            : ''));
                    if (slug) setRedditProfileSlug(slug);
                }
                const subs = items
                    .filter(i => (i.type || i.Type) === 'subreddit')
                    .map(i => ({
                        name: i.srSlug || i.Id || i.id || '',
                        iconUrl: i.iconUrl || i.IconUrl
                    }))
                    .filter(s => s.name);

                setRedditSubs(subs);
                setRedditTarget('profile');
                setRedditSelectedSub('');
            } catch (e) {
                console.error('[Reddit] Failed to load accounts/subreddits:', e);
            }
        }

        if (needReddit && redditSubs.length === 0 && !redditProfileSlug) {
            fetchRedditAccounts();
        }
    }, [selectedChannels]); // eslint-disable-line react-hooks/exhaustive-deps

    // Define the function to get the appropriate icon component
    const GetIconForChannel = (mediumName: string): ReactElement | null => {
        let IconComponent: ComponentType<SvgIconProps> | null = null;

        if (mediumName === "Google") {
            IconComponent = styledIcon(Google);
        } else if (mediumName === "Facebook") {
            IconComponent = styledIcon(Facebook);
        } else if (mediumName === "Pinterest") {
            IconComponent = styledIcon(Pinterest);
        } else if (mediumName === "Instagram") {
            IconComponent = styledIcon(Instagram);
        }
        else if (mediumName === "TikTok") {
            //IconComponent = styledIcon(TikTok);
        }

        return IconComponent ? React.createElement(IconComponent) : null;
    };

    useEffect(() => {
        validateFiles();
        checkandHandleFormValidation();
    }, [selectedChannels, pinterestTitle, instagramCaption, threadsCaption, linkedInCaption, discordMessage, videoTitle, privacyStatus, contentCategory, videoTags, madeForKids, allowEmbedding, publishAndNotifySubscribers, fieldTouched, files, attachedDesigns])

    interface UserAccessTokenValidationResultDTO {
        error: string;
        tokenExpired: boolean;
        providerName: string;
    }


    const validateSelectedChannelAccessTokens = async (channelsData: any) => {
        try {
            let tokenValidationResponse: UserAccessTokenValidationResultDTO[] = (await axios.post('userprofile/ValidateUserAccessTokensForChannels', channelsData)).data;
            const expiredTokens = tokenValidationResponse.filter(d => d.tokenExpired && d.error);
            if (expiredTokens.length > 0) {
                setTokenErrors(expiredTokens.map(token => ({ error: token.error, providerName: token.providerName, tokenExpired: token.tokenExpired })));
            }
        } catch (error) {
            console.error('Error fetching token status:', error)
        }
    }

    const handleTokenExpiredLinkClick = (providerName: string, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        createAndSubmitForm(providerName);
    };
    function createAndSubmitForm(providerName: string) {
        const url = new URL(window.location.href);
        url.searchParams.set("reopenPostDialog", "1");
        const returnUrl = url.pathname + url.search + url.hash;
        var form = document.createElement('form');
        form.setAttribute('method', 'get');
        form.setAttribute('action', '/Identity/Account/ExternalLogin/ExternalClaimProvider?provider=' + providerName);
        form.style.display = 'none'; // Hide the form to avoid changing the page layout

        var returnUrlInput = document.createElement('input');
        returnUrlInput.setAttribute('type', 'hidden');
        returnUrlInput.setAttribute('name', 'returnUrl');
        returnUrlInput.setAttribute('value', returnUrl);
        form.appendChild(returnUrlInput);

        var providerInput = document.createElement('input');
        providerInput.setAttribute('type', 'hidden');
        providerInput.setAttribute('name', 'provider');
        providerInput.setAttribute('value', providerName);
        form.appendChild(providerInput);

        document.body.appendChild(form);

        form.submit();

        setTimeout(() => form.remove(), 100);
    }

    const addImageHandler = (images: File[], videoImage: string) => {
        setShowPexelsSearch(false)
        setVideoImage(videoImage)
        if (images.length > 0) {
            const filesArr = images.map((image) => ({
                file: image,
                orgFn: image.name,
            }));
            setFiles(filesArr);
        }
        console.log(files);

    }

    return (
        <Dialog
            fullWidth
            open={show}
            scroll={'paper'}
            maxWidth='md'
            onClose={handleClose}
            onBackdropClick={handleClose}
            TransitionComponent={Transition}
        >
            <DialogContent
                sx={{
                    position: 'relative',
                    pr: { xs: 5, sm: 12 },
                    pl: { xs: 4, sm: 11 },
                    pt: { xs: 8, sm: 12.5 },
                    pb: { xs: 5, sm: 12.5 }
                }}
            >
                <Typography variant='h4' sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                    Add post
                </Typography>
                <Typography variant='body2' sx={{ mb: 4 }}>
                    Get started quickly by adding posts, select a channel, fill required fields and post to your favorite social
                    platform
                </Typography>
                <IconButton size='small' onClick={handleClose} sx={{ position: 'absolute', right: '1rem', top: '1rem' }}>
                    <Close />
                </IconButton>
                {getTitleMessage() &&
                    <Typography variant="body2" sx={{ paddingLeft: "0px" }}>
                        {getTitleMessage()}
                    </Typography>
                }
                <Grid container>
                    <Toaster
                        position="top-center"
                        toastOptions={{
                            duration: 5000,
                        }} />
                    <Stack width={"100%"} sx={{ mb: 4 }}>
                        <Grid item xs={12}>
                            {availableChannels && (
                                <FormControl variant="filled" size="small" sx={{ width: '100%', mt: 2 }}>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                                        {/* Autocomplete Dropdown */}
                                        <Autocomplete
                                            multiple
                                            options={availableChannels}
                                            filterSelectedOptions
                                            id="channelAutoComplete"
                                            getOptionLabel={(option) => option.name || ''}
                                            sx={{ minWidth: 250, flexGrow: 1 }}
                                            value={selectedChannels}
                                            onChange={(event, newValue) => {
                                                //setSelectedChannelsIds(newValue);
                                                setSelectedChannelIds(
                                                    newValue.map((ch) => `${ch.channelId}|${ch.channelTypeId}|${ch.id}`)
                                                );
                                                const selectedChannelIdsOnly = newValue.map((ch) => ({
                                                    channelId: ch.id,
                                                    mediumName: ch.mediumName,
                                                }));
                                                validateSelectedChannelAccessTokens(selectedChannelIdsOnly);
                                            }}
                                            onBlur={() => setFieldTouched('channelSelection')}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Channels"
                                                    placeholder="Channels"
                                                    variant="outlined"
                                                />
                                            )}
                                            renderOption={(props, option) => (
                                                <MenuItem
                                                    value={`${option.channelId}|${option.channelTypeId}|${option.id}`}
                                                    {...props}
                                                >
                                                    <ListItemIcon>
                                                        <Badge
                                                            overlap="circular"
                                                            badgeContent={GetIconForChannel(option.mediumName)}
                                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                            color="primary"
                                                        >
                                                            <Avatar src={option.profileImageUrl} />
                                                        </Badge>
                                                    </ListItemIcon>
                                                    <ListItemText primary={option.name} />
                                                </MenuItem>
                                            )}

                                        />

                                    </Box>
                                    {formValidationErrors.channelSelection && (
                                        <FormHelperText error>{formValidationErrors.channelSelection}</FormHelperText>
                                    )}
                                </FormControl>
                            )}
                        </Grid>
                        <Stack width={"100%"}>

                            {doesSelectedChannelsContainsMedium('reddit') && (
                                <Box sx={{ mt: 1 }}>
                                    <TextField
                                        label="Reddit Title"
                                        variant="standard"
                                        fullWidth
                                        required
                                        value={redditTitle}
                                        onChange={(e) => setRedditTitle(e.target.value)}
                                        onBlur={() => setFieldTouched('redditTitle')}
                                        error={!!formValidationErrors.redditTitle}
                                        helperText={formValidationErrors.redditTitle}
                                        inputProps={{ maxLength: 300 }}
                                        disabled={disabled}
                                    />
                                </Box>
                            )}

                            {(doesSelectedChannelsContainsMedium('google') ||
                                doesSelectedChannelsContainsMedium('facebook') ||
                                doesSelectedChannelsContainsMedium('tiktok') ||
                                doesSelectedChannelsContainsMedium('reddit')) && (
                                    <InputFieldWithEmojiPicker
                                        label={getLabelForMessageField()}
                                        fieldName='message'
                                        value={message}
                                        onChange={(event) => setMessage(event.target.value)}
                                        errorMessage={formValidationErrors.message}
                                        required={doesSelectedChannelsContainsMedium('facebook') ||
                                            doesSelectedChannelsContainsMedium('google') ||
                                            doesSelectedChannelsContainsMedium('reddit')}
                                        caretPositionRef={messageCaretPositionRef}
                                        setFieldTouched={setFieldTouched}
                                        disabled={disabled}
                                    />
                                )}

                            {doesSelectedChannelsContainsMedium('x') && (
                            <InputFieldWithEmojiPicker
                                label={getLabelForMessageField()}
                                fieldName='caption'
                                value={message}
                                onChange={(event) => setMessage(event.target.value)}
                                errorMessage={formValidationErrors.message}
                                required={doesSelectedChannelsContainsMedium('x')}
                                caretPositionRef={xTitleCaretRef}
                                setFieldTouched={setFieldTouched}
                                disabled={disabled}
                            />
                            )}

                            {doesSelectedChannelsContainsMedium('instagram')  && (
                                <InputFieldWithEmojiPicker
                                    label={'Caption'}
                                    fieldName='message'
                                    value={instagramCaption}
                                    onChange={(event) => setInstagramCaption(event.target.value)}
                                    errorMessage={formValidationErrors.instagramCaption}
                                    required={false}
                                    caretPositionRef={instagramCaretPositionRef}
                                    setFieldTouched={setFieldTouched}
                                    disabled={disabled}
                                />
                            )}

                            {doesSelectedChannelsContainsMedium('threads') && (
                                <InputFieldWithEmojiPicker
                                    label={'Caption'}
                                    fieldName='message'
                                    value={threadsCaption}
                                    onChange={(event) => setThreadsCaption(event.target.value)}
                                    errorMessage={formValidationErrors.threadsCaption}
                                    required={false}
                                    caretPositionRef={threadsCaretPositionRef}
                                    setFieldTouched={setFieldTouched}
                                    disabled={disabled}
                                />
                            )}
                            {doesSelectedChannelsContainsMedium('linkedin') && (
                                <InputFieldWithEmojiPicker
                                    label={'Caption'}
                                    fieldName='message'
                                    value={linkedInCaption}
                                    onChange={(event) => setLinkedInCaption(event.target.value)}
                                    errorMessage={formValidationErrors.linkedInCaption}
                                    required={false}
                                    caretPositionRef={linkedInCaretPositionRef}
                                    setFieldTouched={setFieldTouched}
                                    disabled={disabled}
                                />
                            )}
                            {doesSelectedChannelsContainsMedium('pinterest') && (
                                <InputFieldWithEmojiPicker
                                    label={'Pinterest Post Title'}
                                    fieldName='message'
                                    value={pinterestTitle}
                                    onChange={(event) => setPinterestTitle(event.target.value)}
                                    errorMessage={formValidationErrors.pinterestTitle}
                                    required={false}
                                    caretPositionRef={pinterestCaretPositionRef}
                                    setFieldTouched={setFieldTouched}
                                    disabled={disabled}
                                />
                            )}
                            {doesSelectedChannelsContainsMedium('discord') && (
                                <InputFieldWithEmojiPicker
                                    label={getLabelForMessageField()}
                                    fieldName='Disord Message'
                                    value={discordMessage}
                                    onChange={(event) => setDiscordMessage(event.target.value)}
                                    errorMessage={formValidationErrors.discordMessage}
                                    required={doesSelectedChannelsContainsMedium('discord')}
                                    caretPositionRef={discordMessageCaretRef}
                                    setFieldTouched={setFieldTouched}
                                    disabled={disabled}
                                />
                            )}
                        </Stack>
                        {doesSelectedChannelsContainsMedium('reddit') && (
                            <Box sx={{ mt: 2 }}>
                                <Typography sx={{ mb: 1, fontWeight: 600 }}>Post to</Typography>

                                <RadioGroup
                                    row
                                    value={redditTarget}
                                    onChange={(e) => {
                                        const v = (e.target as HTMLInputElement).value as 'profile' | 'subreddit';
                                        setRedditTarget(v);
                                        if (v === 'profile') setRedditSelectedSub('');
                                    }}
                                    onBlur={() => setFieldTouched('redditTarget')}
                                >
                                    <FormControlLabel
                                        value="profile"
                                        control={<Radio />}
                                        label={redditProfileSlug ? `My profile (${redditProfileSlug.replace('_', '/')})` : 'My profile'}
                                    />
                                    <FormControlLabel
                                        value="subreddit"
                                        control={<Radio />}
                                        label={`A subreddit${redditSubs.length ? ` (${redditSubs.length})` : ''}`}
                                    />
                                </RadioGroup>

                                {redditTarget === 'subreddit' && (
                                    <FormControl variant="filled" size="small" sx={{ width: '100%', mt: 1 }}>
                                        <Autocomplete
                                            options={redditSubs.map(s => s.name)}
                                            value={redditSelectedSub || null}
                                            onChange={(e, v) => setRedditSelectedSub(v || '')}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Choose subreddit"
                                                    variant="outlined"
                                                    error={!!formValidationErrors.redditTarget}
                                                    helperText={formValidationErrors.redditTarget}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                )}
                            </Box>
                        )}

                    </Stack>
                    {attachedDesigns.length > 0 && (
                        <Box sx={{ display: "flex", gap: 2, my: 2, flexWrap: "wrap" }}>
                            {attachedDesigns.map(design => (
                                <Box
                                    key={design.id}
                                    sx={{
                                        position: "relative",
                                        border: "1.5px solid #e7ebf6",
                                        borderRadius: 2,
                                        background: "#fafdff",
                                        p: 0.7,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: 90
                                    }}
                                >
                                    <img
                                        src={design.thumbnailUrl}
                                        alt={design.title}
                                        style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 8, marginBottom: 3 }}
                                    />
                                    <Typography sx={{
                                        fontSize: 11.5,
                                        fontWeight: 500,
                                        color: "#192841",
                                        textAlign: "center",
                                        maxWidth: 74,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}>
                                        {design.title}
                                    </Typography>
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            setAttachedDesigns(prev => prev.filter(d => d.id !== design.id))
                                        }
                                        sx={{
                                            position: "absolute", top: 0, right: 0, color: "#b3bad4", bgcolor: "#fff", m: 0.5,
                                            '&:hover': { color: "#2086F6", bgcolor: "#e5f0ff" }
                                        }}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            ))}
                        </Box>
                    )}

                    <Grid item xs={12}>
                        <FileUploaderCompact
                            updateFiles={updateFiles}
                            selectedChannels={selectedChannels}
                            files={files}
                            handleRemoveFile={handleRemoveFile}
                            videoImage={videoImage}
                            disabled={disabled}
                        />
                        <ErrorDisplay>{fileErrorMessage}</ErrorDisplay>
                    </Grid>

                    {doesSelectedChannelsContainsMedium('google') && <>
                        <Grid item xs={12}>
                            <FormControl variant="filled" size="small" sx={{ width: "100%", mt: 2 }}>
                                <TextField
                                    sx={{ width: "100%", mb: 3 }}
                                    label='Video Title'
                                    variant='standard'
                                    id='textAreaVideoTitle'
                                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                        setVideoTitle(event.target.value)
                                    }}
                                    onBlur={() => setFieldTouched('videoTitle')}
                                    value={videoTitle}
                                />
                            </FormControl>
                            <ErrorDisplay>{formValidationErrors.videoTitle}</ErrorDisplay>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>Privacy Status</Typography>
                            <RadioGroup row aria-label='controlled' name='controlled' value={privacyStatus} onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                setPrivacyStatus(event.target.value)
                            }}
                                onBlur={() => setFieldTouched('privacyStatus')}
                            >
                                <FormControlLabel value='public' control={<Radio />} label='Public' />
                                <FormControlLabel value='private' control={<Radio />} label='Private' />
                                <FormControlLabel value='unlisted' control={<Radio />} label='Unlisted' />
                            </RadioGroup>
                            <ErrorDisplay>{formValidationErrors.privacyStatus}</ErrorDisplay>
                        </Grid>
                        <Grid item xs={6}>
                            {videoCategories.length > 0 && <>
                                <FormControl variant="filled" size="small" sx={{ width: "100%", mt: 2 }}>
                                    <InputLabel id='controlled-select-label'>Video Category</InputLabel>
                                    <Select
                                        value={contentCategory}
                                        label='Controlled'
                                        id='controlled-select'
                                        onChange={(event: SelectChangeEvent) => {
                                            setContentCategory(event.target.value as string)
                                        }}
                                        onBlur={() => setFieldTouched('contentCategory')}
                                        labelId='controlled-select-label'
                                        sx={{ width: "100%" }}
                                    >
                                        {videoCategories.map((vc: any) => <MenuItem value={vc["key"]}>{vc["value"]}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </>
                            }
                            <ErrorDisplay>{formValidationErrors.contentCategory}</ErrorDisplay>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="filled" size="small" sx={{ width: "100%", mt: 2, mb: 2 }}>
                                <TextField
                                    sx={{ width: "100%" }}
                                    label='Video Tags'
                                    variant='standard'
                                    id='textareaVideoTags'
                                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                        setVideoTags(event.target.value)
                                    }}
                                    onBlur={() => setFieldTouched('videoTags')}
                                    value={videoTags}
                                />
                            </FormControl>
                            <ErrorDisplay>{formValidationErrors.videoTags}</ErrorDisplay>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControlLabel
                                label='Made for Kids?'
                                control={<Checkbox checked={madeForKids} onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                    setMadeForKids(event.target.checked)
                                }}
                                    onBlur={() => setFieldTouched('MadeForKids')}
                                    name='MadeForKids' />}
                            />
                            <ErrorDisplay>{formValidationErrors.madeForKids}</ErrorDisplay>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControlLabel
                                label='Allow Embedding'
                                control={<Checkbox checked={allowEmbedding} onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                    setAllowEmbedding(event.target.checked)
                                }}
                                    onBlur={() => setFieldTouched('allowEmbedding')}
                                    name='AllowEmbedding' />}
                            />
                            <ErrorDisplay>{formValidationErrors.allowEmbedding}</ErrorDisplay>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel
                                label='Publish to subscriptions feed and notify subscribers'
                                control={<Checkbox checked={publishAndNotifySubscribers} onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                    setPublishAndNotifySubscribers(event.target.checked)
                                }}
                                    onBlur={() => setFieldTouched('publishAndNotifySubscribers')}
                                    name='PublishAndNotify' />}
                            />
                            <ErrorDisplay>{formValidationErrors.publishAndNotifySubscribers}</ErrorDisplay>
                        </Grid>
                    </>}
                </Grid>
                <Grid>
                    <GptSuggestionsDialog
                        open={dialogOpen}
                        suggestions={suggestions}
                        onClose={() => setDialogOpen(false)}
                        onSelectSuggestion={handleSuggestionSelect}
                    />
                </Grid>

                <Divider>OR</Divider>

                <Stack direction="row" spacing={2} sx={{ width: "100%", mb: 2 }}>
                    <Button
                        onClick={() => setShowPexelsSearch(true)}
                        sx={{
                            borderRadius: 12,
                            flex: 1,
                            minWidth: 0,
                            fontWeight: 700,
                            fontSize: "1.05rem",
                            textTransform: "none"
                        }}
                        variant="outlined"
                        color="secondary"
                        disabled={disabled}
                    >
                        Search Images using Pexels
                    </Button>
                    <Button
                        onClick={() => {
                            if (isGoogleSelected) {
                                toast.error('YouTube only accepts videos uploaded from your device.');
                                return;
                            }
                            setShowLibraryDialog(true);
                        }}
                        sx={{
                            borderRadius: 12,
                            flex: 1,
                            minWidth: 0,
                            background: "#2086F6",
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: "1.05rem",
                            boxShadow: "none",
                            textTransform: "none",
                            "&:hover": { background: "#176CD3" }
                        }}
                        variant="contained"
                        startIcon={<LibraryAdd />}
                        disabled={disabled || isGoogleSelected}
                    >
                        Select Designs from Library
                    </Button>
                </Stack>


                <Grid container spacing={2}>
                    <Grid item xs={12} justifyContent="flex-end">
                        {((!postId && status !== "Draft") || (postId && status === "Draft")) && <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                            {scheduledDateTime != null && (
                                //<div className={"mt-2"} style={{ marginRight: "10px" }}>Scheduled Time : {scheduledDateTime != null && formatDate(scheduledDateTime)} </div>}
                                <Typography
                                    variant="body2"
                                    sx={{ mt: 1, mr: 2 }}
                                >
                                    Scheduled Time: {scheduledDateTime != null && formatDate(scheduledDateTime)}
                                </Typography>
                            )}
                            {fBDTErrMessage && <Typography sx={{
                                color: 'error.main', marginRight: '10px', display: 'flex', alignItems: 'center'
                            }}>{fBDTErrMessage}</Typography>}
                            <ButtonGroup variant='outlined' color='secondary' ref={anchorRef} aria-label='split button'>
                                <Button onClick={handleShowSuggestions} disabled={disabled} sx={{ borderRadius: '4px 0 0 4px' }}>Suggestions</Button>
                                <ClickAwayListener onClickAway={handleDateTimeTooltipClose}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            selectedIndex == 0 &&
                                            <Button
                                                onClick={menuButtonClicked}
                                                color="primary"
                                                disabled={disabled}
                                                sx={{ borderRadius: 0, transition: 'background-color 0.3s' }}
                                            >
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        sx={{
                                                            color: green[500],
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            marginTop: '-12px',
                                                            marginLeft: '-12px',
                                                        }}
                                                    />
                                                )}
                                                {options[selectedIndex]}
                                            </Button>
                                        }
                                        {
                                            selectedIndex == 2 && <>
                                                <Button onClick={menuButtonClicked} sx={{ borderRadius: 0, transition: 'background-color 0.3s' }}>
                                                    {loading && (
                                                        <CircularProgress
                                                            size={24}
                                                            sx={{
                                                                color: green[500],
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '50%',
                                                                marginTop: '-12px',
                                                                marginLeft: '-12px',
                                                            }}
                                                        />
                                                    )}
                                                    Save Post As Draft
                                                </Button>
                                            </>
                                        }
                                        {
                                            selectedIndex == 1 &&
                                            <div style={{ width: 'auto' }}>
                                                <DatePicker
                                                    selected={scheduledDateTime}
                                                    onChange={handleDateTimeChange}
                                                    showTimeSelect
                                                    timeFormat="HH:mm"
                                                    timeIntervals={3}
                                                    timeCaption="time"
                                                    dateFormat="MMMM d, yyyy h:mm aa"
                                                    customInput={<ScheduleButton />}
                                                    minDate={minDate}
                                                    filterTime={time => {
                                                        const compareDate = scheduledDateTime || minDate;
                                                        if (isSameDay(compareDate, minDate)) {
                                                            return time.getTime() >= minDate.getTime();
                                                        }
                                                        return true;
                                                    }}
                                                />
                                            </div>
                                        }
                                        {
                                            selectedIndex === 3 && (
                                                <div
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        fontSize: 0,
                                                    }}
                                                >
                                                <ButtonGroup variant="contained" disableElevation>
                                                    <Box
                                                        
                                                    >
                                                        <DatePicker
                                                            selected={scheduledDateTime}
                                                            onChange={handleDateTimeChange}
                                                            showTimeSelect
                                                            timeFormat="HH:mm"
                                                            timeIntervals={3}
                                                            timeCaption="time"
                                                            dateFormat="MMMM d, yyyy h:mm aa"
                                                            customInput={
                                                                <IconButton
                                                                    edge="start"
                                                                    size="medium"
                                                                    sx={{
                                                                        m: 0,
                                                                        
                                                                        border: '1px solid',
                                                                        borderRight: 0,
                                                                        borderRadius: '0px',
                                                                        fontSize: 'initial', 
                                                                    }}
                                                                >
                                                                    <AccessTimeIcon />
                                                                </IconButton>
                                                            }
                                                            minDate={minDate}
                                                            filterTime={time => {
                                                                const compareDate = scheduledDateTime || minDate;
                                                                if (isSameDay(compareDate, minDate)) {
                                                                    return time.getTime() >= minDate.getTime();
                                                                }
                                                                return true;
                                                            }}
                                                        />
                                                    </Box>

                                                    <Button
                                                        onClick={menuButtonClicked}
                                                        sx={{
                                                            m: 0,
                                                            ml: 0,
                                                            p: '6px 16px',
                                                            border: '1px solid',
                                                            borderLeft: 0,
                                                            borderRadius: '0 4px 4px 0',
                                                            fontSize: 'initial',
                                                            position: 'relative',
                                                        }}
                                                        disabled={!scheduledDateTime || loading}
                                                    >
                                                        {loading && (
                                                            <CircularProgress
                                                                size={24}
                                                                sx={{
                                                                    color: green[500],
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    marginTop: '-12px',
                                                                    marginLeft: '-12px',
                                                                }}
                                                            />
                                                        )}
                                                        Schedule
                                                    </Button>
                                                        
                                                    </ButtonGroup>
                                                </div>
                                            )
                                        }
                                        <div>
                                            <HtmlTooltip
                                                PopperProps={{
                                                    disablePortal: true,
                                                }}
                                                disableFocusListener
                                                disableHoverListener
                                                disableTouchListener
                                                onClose={handleDateTimeTooltipClose}
                                                open={showDateTimeComponent}
                                                title={
                                                    <>
                                                    </>
                                                }
                                                placement="left-start"
                                            >
                                                <span></span>
                                            </HtmlTooltip>
                                        </div>
                                    </Box>
                                </ClickAwayListener>
                                <Button
                                    sx={{ px: 0, borderRadius: '0 4px 4px 0' }}
                                    aria-haspopup="menu"
                                    disabled={disabled}
                                    onClick={handlePopperToggle}
                                    aria-label="select merge strategy"
                                    aria-expanded={open ? 'true' : undefined}
                                    aria-controls={open ? 'split-button-menu' : undefined}
                                >
                                    <Icon icon="mdi:menu-down" />
                                </Button>
                            </ButtonGroup>
                            <Popper open={popperOpen} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                    >
                                        <Paper>
                                            <ClickAwayListener onClickAway={handlePopperClose}>
                                                <MenuList id='split-button-menu'>
                                                    {options.map((option, index) => (
                                                        <MenuItem
                                                            key={option}
                                                            disabled={index === 3}
                                                            selected={index === selectedIndex}
                                                            onClick={event => handleMenuItemClick(event, index)}
                                                        >
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </Box>
                        }
                        {
                            postId > 0 && (status == "Scheduled" || status == "Delivered" || status == "Pending") && <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                                {scheduledDateTime != null && <div className={"mt-2"} style={{ marginRight: "10px" }}>Scheduled Time : {scheduledDateTime != null && formatDate(scheduledDateTime)} </div>}
                                {fBDTErrMessage && <div className={"mt-2"} style={{ marginRight: "10px" }}>{fBDTErrMessage}</div>}
                                <ButtonGroup variant='outlined' color='secondary' ref={anchorRef} aria-label='split button'>
                                    {
                                        selectedIndex == 1 &&
                                        <DatePicker
                                            selected={scheduledDateTime}
                                            onChange={handleDateTimeChange}
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={3}
                                            timeCaption="time"
                                            dateFormat="MMMM d, yyyy h:mm aa"
                                            customInput={<ScheduleButton value="Adjust Schedule" />}
                                            minDate={minDate}
                                        />
                                    }
                                    <div>
                                        <HtmlTooltip
                                            PopperProps={{
                                                disablePortal: true,
                                            }}
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            onClose={handleDateTimeTooltipClose}
                                            open={showDateTimeComponent}
                                            title={
                                                <>
                                                </>
                                            }
                                            placement="left-start"
                                        >
                                            <span></span>
                                        </HtmlTooltip>
                                    </div>
                                    {
                                        selectedIndex == 3 && <>
                                            <Button onClick={menuButtonClicked} sx={{ borderRadius: 0 }}>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        sx={{
                                                            color: green[500],
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            marginTop: '-12px',
                                                            marginLeft: '-12px',
                                                        }}
                                                    />
                                                )}
                                                Schedule
                                            </Button>
                                        </>
                                    }
                                </ButtonGroup>
                            </Box>
                        }
                    </Grid>
                </Grid>
                {
                    showPexelsSearch && (
                        <PexelsSearch onClose={() => { setShowPexelsSearch(false); }} onAddImages={addImageHandler} />
                    )
                }
            </DialogContent >
            <MediaLibraryDialog
                open={showLibraryDialog}
                onClose={() => setShowLibraryDialog(false)}
                onSelect={(designs) => {
                    setAttachedDesigns(prev => {
                        const ids = new Set(prev.map(d => d.id));
                        return [...prev, ...designs.filter(d => !ids.has(d.id))];
                    });
                    setShowLibraryDialog(false);
                }}
                multiSelect={true}
            />

        </Dialog >
    )
}

export default PostContentDialog